import { WarningOctagon, ArrowClockwise } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export interface DashboardErrorStateProps {
  title: string;
  description: string;
  retryLabel: string;
  onRetry?: () => void;
  className?: string;
}

export function DashboardErrorState({
  title,
  description,
  retryLabel,
  onRetry,
  className,
}: DashboardErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        "mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-biz-card border border-biz-danger-border bg-biz-danger-subtle/40 p-8 text-center",
        className,
      )}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-biz-danger text-biz-danger-foreground">
        <WarningOctagon className="h-6 w-6" weight="fill" aria-hidden />
      </div>
      <h2 className="text-base font-semibold text-biz-foreground">{title}</h2>
      <p className="text-sm text-biz-foreground-muted">{description}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 inline-flex h-10 items-center gap-2 rounded-biz-btn bg-biz-primary px-4 text-sm font-semibold text-biz-primary-foreground transition-colors hover:bg-biz-primary-hover biz-focus-ring"
        >
          <ArrowClockwise className="h-4 w-4" weight="bold" aria-hidden />
          {retryLabel}
        </button>
      )}
    </div>
  );
}
